import * as types from '../../mutation-types'
// import statistics from './statistics'
// import forms from './forms'
import lastOperations from './lastOperations'
import helpdesk from './helpdesk'
import profile from './profile'
import balance from './balance'
import deposit from './deposit'
// import depositBank from './deposit_bank'
import createDeposit from './create_deposit'
import withdraw from './withdraw'
// import ui from './ui'
// import maps from './maps'
// import tables from './tables'
import auth from './auth'

// import extra from './extra'
// import mitem from './mitem'


const state = {
  items: [
    balance,
    profile,
    createDeposit,
    // depositBank,
    deposit,
    withdraw,
    lastOperations,
    helpdesk,
    // forms,
    // tables,
    // ui,
    // extra,
    // mitem,
    auth
    // maps
  ]
}

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM] (state, payload) {
    let menuItem = payload.menuItem
    let expand = payload.expand
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand
    }
  }
}

const actions = {
  toggleExpandMenuItem ({commit}, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js